import { RouterLink } from '../../generic/Link';


const ForgotPasswordLink = () => (
  <div className="fossa-auth__form__forgot-password">
    <RouterLink to="/auth/password-reset">
      Forgot password?
    </RouterLink>
  </div>
);

export default ForgotPasswordLink;
